// // import React, { useState } from "react";
// // import "../ProductCategory/productCategory.scss";
// // import axios from "axios";
// // import { useNavigate } from "react-router-dom";
// // import { API_BASE_URL } from "../../../utils/index";
// // import Swal from "sweetalert2/dist/sweetalert2.js";
// // import { useAuthHeaders } from "../../../components/Token";
// // import { Modal, Button, Form } from "react-bootstrap";
// // function ProductCategory() {
// //   const [categoryname, setCategory] = useState("");

// //   const navigate = useNavigate();
// //   const headers = useAuthHeaders();

// //   const handleCategoryCreation = (e) => {
// //     e.preventDefault();

// //     axios
// //       .post(
// //         `${API_BASE_URL}/category`,
// //         {
// //           categoryname: categoryname
// //         },
// //         {
// //           headers,
// //         }
// //       )
// //       .then((result) => {
// //         console.log("create category response:", result);
// //         Swal.fire({
// //           icon: "success",
// //           title: "Category has been created",
// //           showConfirmButton: false,
// //           timer: 1500,
// //         });
// //         navigate("/category"); // Redirect to category page after successful creation
// //       })
// //       .catch((error) => {
// //         console.error("Error creating category:", error);
// //         Swal.fire({
// //           icon: "error",
// //           title: "Oops...",
// //           text: error.response.data.error,
// //         });
// //       });
// //   };

// //   return (

// //     <>

// //       <Modal>

// //         <div className='x'>
// //           <Modal.Header closeButton>
// //             <Modal.Title className='text-center'>
// //               Create Category
// //               <h5 className='text-center ms-5'></h5>
// //             </Modal.Title>
// //           </Modal.Header>
// //           <Form onSubmit={handleCategoryCreation}>
// //             <Form.Group controlId="formEmail">
// //               <Form.Label className='mx-5'>Create Category Name</Form.Label>
// //               <div className='boxs-1'>
// //                 <input
// //                   type="text"
// //                   id="name"
// //                   onChange={(e) => setCategory(e.target.value)}
// //                 />
// //                 {/* <MdOutlineAlternateEmail className="text-indent" id="btnicon" /> */}
// //               </div>
// //             </Form.Group>

// //             <div className="buttons">
// //               <button type="submit" value="send">
// //                 Save
// //               </button>

// //             </div>
// //           </Form>

// //           <Modal.Footer>
// //             <Button variant="secondary" >
// //               Cancel
// //             </Button>
// //           </Modal.Footer>
// //         </div>
// //       </Modal >

// //     </>
// //   );
// // }

// // export default ProductCategory;
// import React, { useState } from "react";
// import "../ProductCategory/productCategory.scss";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { API_BASE_URL } from "../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../components/Token";
// import { Modal, Button, Form } from "react-bootstrap";
// import TextField from "@mui/material/TextField";
// function ProductCategory() {
//   const [categoryname, setCategory] = useState("");
//   const [show, setShow] = useState(false);

//   const navigate = useNavigate();
//   const headers = useAuthHeaders();

//   const handleCategoryCreation = (e) => {
//     e.preventDefault();

//     axios
//       .post(
//         `${API_BASE_URL}/category`,
//         {
//           categoryname: categoryname,
//         },
//         {
//           headers,
//         }
//       )
//       .then((result) => {
//         console.log("create category response:", result);
//         Swal.fire({
//           icon: "success",
//           title: "Category has been created",
//           showConfirmButton: false,
//           timer: 1500,
//         });
//         setShow(false);
//         navigate("/category"); // Redirect to category page after successful creation
//       })
//       .catch((error) => {
//         console.error("Error creating category:", error);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response?.data?.error || "An error occurred",
//         });
//       });
//   };

//   const handleShow = () => setShow(true);
//   const handleClose = () => setShow(false);

//   return (
//     <>
//       <Button variant="warning" onClick={handleShow}>
//         Create Category
//       </Button>

//       <Modal show={show} onHide={handleClose}>
//         <Modal.Header closeButton>
//           <Modal.Title className="text-center">
//             Create Category
//             <h5 className="text-center ms-5"></h5>
//           </Modal.Title>
//         </Modal.Header>
//         <Form onSubmit={handleCategoryCreation}>
//           <Modal.Body>
//             <Form.Group controlId="formCategoryName">
//               <div className="m-auto">
//                 <TextField
//                   id="name"
//                   label="Create Category Name"
//                   value={categoryname}
//                   onChange={(e) => setCategory(e.target.value)}
//                   required
//                 />
//               </div>
//             </Form.Group>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={handleClose}
//               className="me-auto"
//             >
//               Cancel
//             </Button>
//             <Button type="submit" variant="dark">
//               Save
//             </Button>
//           </Modal.Footer>
//         </Form>
//       </Modal>
//     </>
//   );
// }

// export default ProductCategory;



import React, { useState } from "react";
import "../ProductCategory/productCategory.scss";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../utils/index";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { useAuthHeaders } from "../../../components/Token";
import { Modal, Button, Form } from "react-bootstrap";
import TextField from "@mui/material/TextField";

function ProductCategory({ show, handleClose, fetchCategories }) {
  const [categoryname, setCategory] = useState("");

  const navigate = useNavigate();
  const headers = useAuthHeaders();

  const handleCategoryCreation = (e) => {
    e.preventDefault();

    axios
      .post(
        `${API_BASE_URL}/category`,
        {
          categoryname: categoryname,
        },
        {
          headers,
        }
      )
      .then((result) => {
        console.log("create category response:", result);
        Swal.fire({
          icon: "success",
          title: "Category has been created",
          showConfirmButton: false,
          timer: 1500,
        });
        handleClose();
        fetchCategories();
        navigate("/category"); // Redirect to category page after successful creation
      })
      .catch((error) => {
        console.error("Error creating category:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.error || "An error occurred",
        });
      });
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="text-center" >
          <Modal.Title className="m-auto fw-bold " >
            Create Type
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleCategoryCreation}>
          <Modal.Body>
            <Form.Group controlId="formCategoryName">
              <div className="text-center" >
                <TextField
                
                  label="Create Type Name"
                  value={categoryname}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                 className="m-auto"
                 style={{alignItems:"center"}}
                />
              </div>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer className="m-auto" style={{justifyContent:"center"}}>
            <Button
              variant="warning"
              onClick={handleClose}
              
            >
              Cancel
            </Button>
            <Button type="submit" variant="dark" >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default ProductCategory;
  